<div class="container"
     *ngIf="isVisible">
  <button class="menu-item pop-no-button"
          [class.menu-link]="menuSection.route"
          (click)="toggle()"
          [routerLink]="menuSection.route"
          routerLinkActive="active-item">
    <i class="main-icon {{ menuSection.mainIconClass }}"></i>

    <div [translate]="menuSection.titleKey"></div>
    <i *ngIf="menuSection.children.length"
       [class.fa-chevron-down]="isExpanded"
       [class.fa-chevron-right]="!isExpanded"
       class="chevron-icon far"></i>
  </button>
  <hr />
  <ng-container *ngIf="isExpanded">
    <a *ngFor="let menuItem of menuSection.children"
       class="menu-item pop-no-link"
       [class.menu-link]="menuItem.route"
       [routerLink]="menuItem.route"
       routerLinkActive="active-item">
      <i class="main-icon {{menuItem.mainIconClass}}"></i>
      <div class="menu-button"
           [translate]="menuItem.titleKey"></div>
    </a>
    <hr />
  </ng-container>
</div>
